<template>
	<tool-dialog
		v-bind="$props"
		:searchable="false"
		:expandable="true"
		:display-name="$t('tours.stop-manager')"
		v-on="$listeners"
	>
		<div v-if="activeTour" class="library">
			<table class="library-table">
				<thead class="header">
					<tr>
						<th />
						<th class="heading">
							{{ $t('tours.name') }}
						</th>
						<th class="heading">
							{{ $t('tours.modified') }}
						</th>
						<th colspan="2" />
					</tr>
				</thead>
				<tbody>
					<tr
						v-for="(stop, index) in activeTour.data.stops"
						:key="index"
						:class="{'active': index === activeTour.data.activeStopIndex}"
					>
						<template v-if="index === renameTourStopIndex">
							<td colspan="2">
								<b-form-input
									:value="stop.name"
									@input="newTourStopName = $event"
									@keyup.enter.native="renameStop(index, newTourStopName)"
								/>
							</td>
							<td>					
								<b-button @click="renameStop(index, newTourStopName)">
									<b-icon icon="check" />
								</b-button> 
							</td>
							<td>
								<b-button
									variant="dark"
									@click="renameTourStopIndex = null"
								>
									<b-icon icon="x" />
								</b-button>
							</td>
						</template>
						<template v-else>
							<td><i :class="'tan-icon-'+(stop.type==='canvas'?'map':'create-new')" /></td>
							<td class="tour-stop-name" @click="selectStop(index)">
								{{ stop.name }}
							</td>
							<td>{{ stop.modified.toLocaleString() }}</td>
							<td>
								<b-dropdown size="sm" variant="default" no-caret>
									<template #button-content>
										<b-icon icon="three-dots" />
									</template>
									<b-dropdown-item @click="selectStop(index)">
										{{ $t('tours.set-active-stop') }}
									</b-dropdown-item>
									<b-dropdown-item @click="copyStop(index)">
										{{ $t('tours.copy-stop') }}
									</b-dropdown-item>
									<b-dropdown-item v-if="tourClipboard" @click="pasteStop(index)">
										{{ $t('tours.paste-stop') }}
									</b-dropdown-item>
									<b-dropdown-item @click="renameTourStopIndex = index">
										{{ $t('tours.rename-stop') }}
									</b-dropdown-item>
									<b-dropdown-item @click="deleteStop(index)">
										{{ $t('tours.delete-stop') }}
									</b-dropdown-item>
								</b-dropdown>
							</td>
						</template>
					</tr>
				</tbody>
			</table>
			<div class="new-buttons">
				<b-button><i class="tan-icon-group" />{{ $t('tours.new-folder') }}</b-button>
				<b-button class="new-stop" variant="primary" @click="newStop">
					<i class="tan-icon-add-secondary" />{{ $t('tours.new-stop') }}
				</b-button>
			</div>
		</div>
		<div v-else class="library">
			<table class="library-table">
				<tbody class="tours">
					<tr>
						<td>
							{{ $t('tours.no-tour') }}
						</td>
					</tr>
				</tbody>
			</table>
		</div>
	</tool-dialog>
</template>

<script>
import { mapGetters, mapState, mapMutations } from 'vuex';
import BaseTool from '@/components/Project/Tool/BaseTool.vue';

export default {
	name: 'TourStopManager',
	extends: BaseTool,
	data() {
		return {
			renameTourStopIndex: null,
			newTourStopName: null,
		};
	},
	computed: { ...mapGetters(['activeTour', 'getTourClipboard']), ...mapState(['openPanels', 'tourClipboard']) },
	methods: {
		...mapMutations([
			'openPanel',
			'setActiveTourStop',
			'setCreateTourStopIsOpen',
			'setCreateTourStopMode',
			'moveActiveTourStop',
			'deleteTourStop',
			'setTourClipboard',
			'addActiveTourStop',
			'setElementEditorEntityDataId',
		]),
		newStop() {
			this.setCreateTourStopMode('createButtons');
			this.setCreateTourStopIsOpen(true);
		},
		// selectStop needs to be refactored; it's currently copied into here from TourPlayback.vue.
		// It should be refectored into its own module and then imported.
		// (this.updatePlaybackInterface() only exists in TourPlayback.vue)
		selectStop(index) {
			this.setActiveTourStop(index);
			if (this.activeTour.data.stops[index] && this.activeTour.data.stops[index].projectTools) {
				this.openPanels.projectTools = this.activeTour.data.stops[index].projectTools;
				if (
					this.activeTour.data.stops[index].projectTools.wide.tools.length >= 1 &&
					this.activeTour.data.stops[index].elementEditor
				) {
					for (const currentPanel of this.activeTour.data.stops[index].projectTools.wide.tools) {
						if (currentPanel.componentName === 'BuildingInputForm') {
							this.setElementEditorEntityDataId(this.activeTour.data.stops[index].elementEditor);
							break;
						}
					}
				}
			}
			this.$czm('flyToStop', this.activeTour.data.stops[index]);
		},
		renameStop(index, newTourStopName) {
			this.activeTour.data.stops[index].name = newTourStopName;
			this.updateTour(
				this.activeTour.scenarioId,
				this.activeTour.id,
				JSON.parse(JSON.stringify(this.activeTour))
			);
			this.renameTourStopIndex = null;
		},
		// updateTour is in BaseTool.vue
		deleteStop(index) {
			this.deleteTourStop(index);
			this.updateTour(
				this.activeTour.scenarioId,
				this.activeTour.id,
				JSON.parse(JSON.stringify(this.activeTour))
			);
		},
	},
};
</script>

<!--TODO extract this to an SCSS file shared between this component and TourLibrary-->
<style scoped>
.library {
	margin: 1rem auto;
	width: calc(100% - 2rem);
}

.library-table {
	background: #ffffff;
	width: 100%;
}

.header {
	background: #ffffff;
	color: #999999;
	font-style: italic;
	text-decoration: underline;
}

.heading {
	font-weight: normal;
	width: 50%;
}

.active {
	background: #9a9999;
	font-weight: bold;
}

.context-menu-button {
	background: transparent;
	color: #dddddd;
	border: none;
}

.new-buttons {
	display: flex;
}

.new-stop {
	flex: 1;
}

.tour-stop-name {
	cursor: pointer;
}
</style>